export default {
  methods: {
    isRelativeUrl (url) {
      if (!url) return false
      return !(url.includes('http://') || url.includes('https://'))
    }
  }
}
